module.exports = __webpack_public_path__ + "media/images/flags/GH-ea07b698d4919ae7121b7061c9ff1833.svg";